import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import './index.scss';
import api from '../api';

const PrivateRoute = ({ element: Element, acessosPermitidos }) => {
    const [user, setUser] = useState(null);
    const [emailNaoVerificado, setEmailNaoVerificado] = useState(false);
    const [emailPendenteVerificacao, setEmailPendenteVerificacao] = useState('');
    const [loading, setLoading] = useState(true);
    const [siteStatus, setSiteStatus] = useState('online');

    const acessosKey = Array.isArray(acessosPermitidos) ? acessosPermitidos.join('|') : '';

    useEffect(() => {
        const verificarToken = async () => {
            try {
                const [statusRes, tokenRes] = await Promise.allSettled([
                    api.get('/api/site-status'),
                    api.get('/api/verificar-token', { withCredentials: true })
                ]);

                if (statusRes.status === 'fulfilled') {
                    setSiteStatus(statusRes.value.data?.status || 'online');
                }

                if (tokenRes.status === 'fulfilled') {
                    const response = tokenRes.value;
                    console.log('✅ Usuário autenticado:', response.data.user);
                    if (response.data.success) {
                        const usuario = response.data.user;

                        if (!usuario.email_verificado) {
                            setEmailNaoVerificado(true);
                            setEmailPendenteVerificacao(usuario.email || '');
                            return;
                        }

                        if (acessosPermitidos.includes(usuario.nivel_acesso)) {
                            setUser(usuario);
                        }
                    }
                }
            } catch (error) {
                console.error('Token inválido ou não encontrado:', error.response?.data || error.message);
            } finally {
                setLoading(false);
            }
        };
        verificarToken();
    }, [acessosKey]);

    if (loading) {
        return (
            <div className='loading-routes'>
                
                <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'>
                    <path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' />
                    <path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'>
                        <animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' />
                    </path>
                </svg>
                <h2>Carregando...</h2>
            </div>
        );
    }

    if (siteStatus === 'manutencao' && user?.nivel_acesso !== 'Administrador') {
        return <Navigate to="/manutencao" />;
    }

    if (emailNaoVerificado) {
        return <Navigate to="/confirmacao-email" state={{ email: emailPendenteVerificacao }} replace />;
    }

    if (!user) return <Navigate to="/login" />;

    return <Element />;
};

export default PrivateRoute;
